/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import { APPROVE_APPLICATION } from "../pages/OcApplicationDetails/graphql/approveApplication.mutation";
import { GENERATE_APPLICATION } from "../pages/OcApplicationDetails/graphql/generateApplication.mutation";
import { CANCEL_APPLICATION } from "../pages/OcApplicationDetails/graphql/cancelApplication.mutation";
import { string } from "yup";

const MODULE_NAME = "ApproveApplicationService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ApproveApplicationService {
    private static instance: ApproveApplicationService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): ApproveApplicationService {
        if (!ApproveApplicationService.instance) {
            ApproveApplicationService.instance = new ApproveApplicationService(
                props
            );
        }
        return ApproveApplicationService.instance;
    }
    
    async approveApplication(data: any) {

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `approve Application data in service`, data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: APPROVE_APPLICATION,
                    variables: {
                        input: {
                            applicationId: data
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(
                    MODULE_NAME,
                    "Update payment Receipt result : ",
                    res
                );
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async onApproveApplication(data: any) {

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log(`on generate approve Application data in service`, data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: GENERATE_APPLICATION,
                    variables: {
                        input: {
                            applicationId: data
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(
                    MODULE_NAME,
                    "Update payment Receipt result : ",
                    res
                );
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async onRejectApplication(data: any) {

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log(`on reject Application data in service`, data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CANCEL_APPLICATION,
                    variables: {
                        previewUrl:data
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(
                    MODULE_NAME,
                    "Reject/Cancel Application result : ",
                    res
                );
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }


}
